import React, { useState } from "react";
import { Box, Button, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, Popover, Typography } from "@mui/material";
import Signature from "../../Components/Signature/Signature";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import { updateAuthorization } from "../../redux/user/userSlice";
import { useTranslation } from "react-i18next";
import { API } from "../../utils/http";
export default function Authorization(props) {
	const { handleNext, handleBack, renderControls, title, verifier } = props;
	const [error, setError] = useState({});
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const authorization = useSelector((state) => state.user.application.authorization);
	const applicationId = useSelector((state) => state.user.application.personalInformation.id);
	const handleAuthorizationChange = (e) => {
		dispatch(updateAuthorization(e.target.checked));
	};
	const handleNextButton = () => {
		console.log("verify authorization: ", authorization);
		const errors = verifier(authorization);
		console.log(errors);
		if (Object.keys(errors).length == 0) {
			handleNext();
			setError({});
		} else {
			setError(errors);
		}
	};
	const [pdf, setPdf] = useState();

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl) && pdf;
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
		API.get(`/consent-form/${applicationId}`)
			.then((r) => {
				console.log(r);
				const base64Pdf = r.data;
				console.log(base64Pdf);

				const binaryString = window.atob(base64Pdf); // Comment this if not using base64
				const bytes = new Uint8Array(binaryString.length);
				const arrayBuffer = bytes.map((byte, i) => binaryString.charCodeAt(i));

				var blob = new Blob([arrayBuffer], { type: "application/pdf" });

				setPdf(window.URL.createObjectURL(blob));
			})
			.catch((e) => {
				console.log(e);
				alert("Could not get consent");
			});
	};
	return (
		<React.Fragment>
			<Typography>{title}</Typography>
			<Grid container>
				<Grid item xs={12} marginBottom={2}>
					<Typography>{t("Please read the following terms and conditions")}</Typography>
				</Grid>
				<Grid item xs={12} marginBottom={2}>
					<Typography>{t("Full Consent Text")}</Typography>
				</Grid>
				{/* <Grid item xs={12} marginBottom={2}>
					<Typography>
						We require a signature to confirm that you accept all terms and conditions. Sign on the line with your finger. When complete, you should see your
						signature below.
					</Typography>
				</Grid> */}
				<Grid item xs={12} marginBottom={2}>
					{/* <Signature /> */}
					<FormControl required error={!!error.authorization}>
						<FormGroup>
							<FormControlLabel
								control={<Checkbox required name="authorization" checked={authorization} onChange={handleAuthorizationChange} />}
								label={t("Yes, I agree")}
							/>
						</FormGroup>
						<FormHelperText
							sx={{
								display: error.authorization ? "initial" : "none",
								fontSize: "1rem",
							}}
						>
							{t("You must check this box if you want to proceed")}
						</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={12} marginBottom={2}>
					{/* <Button variant="outlined" style={{ textTransform: "capitalize" }} onClick={handleClick} disabled={!authorization}>
						View Consent
					</Button> */}
					<Popover
						open={open}
						anchorEl={anchorEl}
						onClose={handleClose}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "center",
						}}
					>
						<Box style={{ width: "500px" }}>
							<embed src={pdf} type="application/pdf" width="100%" height="600px" />
						</Box>
					</Popover>
				</Grid>
			</Grid>
			{renderControls(handleNextButton, handleBack)}
		</React.Fragment>
	);
}
